import { Controller } from '@hotwired/stimulus';

/**
 * Stimulus Controller para InputNumber
 *
 * Gerencia comportamentos e validações adicionais para campos numéricos.
 */
export default class extends Controller {
    connect() {
        this.inputElement = this.element.querySelector('input') || this.element;
        // Adicione comportamentos comuns do InputNumber aqui se necessário (ex: botões de incremento/decremento customizados)
    }
}
